import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './VXGrid.less';

export default class Row extends PureComponent {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        id: PropTypes.string,
        fluid: PropTypes.bool,
        gutterSize: PropTypes.oneOf([0, 10, 30])
    };

    static defaultProps = {
        gutterSize: 30
    };

    render() {
        const { children, className, fluid, gutterSize, id } = this.props;
        const wrapperClasses = [
            'Row',
            fluid ? 'vx_row_fluid' : 'vx_row',
            `gutter-${gutterSize}`,
            className ? className : ''
        ];

        return (
            <div id={id} className={wrapperClasses.join(' ')}>{children}</div>
        );
    }
}
